export const FINANCIAL_STATEMENTS = [
  {
    label: 'Balance Sheet',
    slug: 'balance-sheet',
    titleKey: 'balance_sheet',
    dataKey: 'balance_sheet',
  },
  {
    label: 'Statement of Cash Flows',
    slug: 'statement-of-cash-flows',
    titleKey: 'cash_flow_statement',
    dataKey: 'cash_flow_statement',
  },
  {
    label: 'Income Statement',
    slug: 'income-statement',
    titleKey: 'income_statement',
    dataKey: 'income_statement',
  },
];

export const DEFAULT_FINANCIAL_STATEMENT = FINANCIAL_STATEMENTS[0];

export function getFinancialStatementBySlug(statementSlug) {
  return (
    FINANCIAL_STATEMENTS.find(({ slug }) => slug === statementSlug) ??
    DEFAULT_FINANCIAL_STATEMENT
  );
}

export function isKnownFinancialStatementSlug(statementSlug) {
  return FINANCIAL_STATEMENTS.some(({ slug }) => slug === statementSlug);
}

export function getFinancialStatementByLabel(label) {
  return (
    FINANCIAL_STATEMENTS.find((statement) => statement.label === label) ??
    DEFAULT_FINANCIAL_STATEMENT
  );
}
